import { useGlobalStore } from '@shared/stores/Global';

export const globalSingleMediaPlay = () => {
	const channel = new BroadcastChannel('media-control-channel');

	const pauseAll = () => {
		const medias = document.querySelectorAll('audio, video') as NodeListOf<HTMLMediaElement>;
		medias.forEach((media) => {
			if (!media.paused && !media.muted) media.pause();
		});
	};

	const handleOnPlay = (e: Event) => {
		if (!(e.target instanceof HTMLMediaElement)) return;
		if (e.target.muted) return;

		// 通知其他标签页暂停
		channel.postMessage('pause-others');
		const medias = document.querySelectorAll('audio, video') as NodeListOf<HTMLMediaElement>;

		medias.forEach((media) => {
			if (media !== e.target && !media.paused && !media.muted) {
				media.pause();
			}
		});
	};

	const handleOnMessage = (e: MessageEvent) => {
		if (e.data === 'pause-others') pauseAll();
	};

	document.addEventListener('play', handleOnPlay, true);
	channel.addEventListener('message', handleOnMessage);

	// 监听页面是否完成过交互
	const interactiveCallback = () => {
		setTimeout(() => {
			useGlobalStore.setState({
				interactive: true,
			});
		});

		window.removeEventListener('keypress', interactiveCallback, true);
		window.removeEventListener('click', interactiveCallback, true);
		window.removeEventListener('touchstart', interactiveCallback, true);
	};

	window.addEventListener('keypress', interactiveCallback, true);
	window.addEventListener('click', interactiveCallback, true);
	window.addEventListener('touchstart', interactiveCallback, true);
};
